// extracted by mini-css-extract-plugin
export default {"StrollerDetailRating":"xz_a bie_a bie_x","StrollerDetailRating__muted":"xz_b bie_fo"};